"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getCategoryProperty_1 = __importDefault(require("./getCategoryProperty"));
const hash_1 = __importDefault(require("../hash"));
const dateFormat_1 = __importDefault(require("./dateFormat"));
const encodeABSwitches = (config) => Object.keys(config)
    .map((name) => `${name}_${config[name].group}`.toLowerCase())
    .join('|');
// all documentation for these properties can be found here -> https://ecgwiki.corp.ebay.com/pages/viewpage.action?spaceKey=ANYL&title=Data+Layer
class DataLayerBuilder {
    // must initialise with empty object
    _dataLayer = [{}];
    constructor() {
        this.withSearchDefaults().withLocationDefaults().withMessageDefaults();
    }
    withSearchDefaults() {
        this._dataLayer[0].s = {
            pn: -1,
            ps: -1,
            tr: -1,
            srt: {},
            prc: {
                mn: -1,
                mx: -1,
            },
        };
        return this;
    }
    withLocationDefaults() {
        this._dataLayer[0].l = {
            d: -1.0,
        };
        return this;
    }
    withMessageDefaults() {
        this._dataLayer[0].m = {};
        return this;
    }
    withPageTypeAndLang(pageType, acceptedLanguage) {
        this._dataLayer[0].p = {
            t: pageType,
            lng: acceptedLanguage,
        };
        return this;
    }
    withCategoryData(categories) {
        this._dataLayer[0].c = (0, getCategoryProperty_1.default)({ categories });
        return this;
    }
    withLoggedInUserInfo(loggedInUser) {
        this._dataLayer[0].u = {
            ...this._dataLayer[0].u,
            li: Boolean(loggedInUser),
        };
        if (!loggedInUser)
            return this;
        this._dataLayer[0].u = {
            ...this._dataLayer[0].u,
            at: loggedInUser.accountType,
            a_cre: (0, dateFormat_1.default)(loggedInUser.confirmDate),
            huid: loggedInUser.encryptedId,
            hue: loggedInUser.hashedEmail,
            lar: loggedInUser.lastAdRepliedTime,
            lap: loggedInUser.lastAdPostedTime,
        };
        return this;
    }
    withAbSwitchesInfo(abSwitches) {
        if (!abSwitches)
            return this;
        this._dataLayer[0].u = {
            ...this._dataLayer[0].u,
            tg: {
                stg: encodeABSwitches(abSwitches),
            },
        };
        return this;
    }
    withSellerBehaviour(sellerBehaviour) {
        if (!sellerBehaviour)
            return this;
        this._dataLayer[0].u = {
            ...this._dataLayer[0].u,
            ss: sellerBehaviour,
        };
        return this;
    }
    withCookiesAndUserAgents(req) {
        const userPermanentCookie = '__mpx';
        const sessionCookie = 'MpSession';
        this._dataLayer[0].d = {
            ck: (0, hash_1.default)(req.cookies[userPermanentCookie]),
            s_ck: req.cookies[sessionCookie],
            ua: req.get('user-agent'),
        };
        return this;
    }
    withAdDetails(adDetails) {
        this._dataLayer[0].a = adDetails;
        return this;
    }
    withOrderDetails(orderDetails) {
        this._dataLayer[0].o = orderDetails;
        return this;
    }
    withConsentToAllPurposes(consentedToAllPurposes) {
        this._dataLayer.push({
            consentToAllPurposes: consentedToAllPurposes,
        });
        return this;
    }
    withUserData(loggedInUser, labsConfig) {
        if (!loggedInUser?.email || !labsConfig?.featureSwitches?.includes('GOOGLE_ENHANCED_CONVERSIONS'))
            return this;
        this._dataLayer.push({
            user_data: {
                sha256_email_address: (0, hash_1.default)(loggedInUser.email.toLowerCase()),
            },
        });
        return this;
    }
    build() {
        return this._dataLayer;
    }
}
exports.default = DataLayerBuilder;
//# sourceMappingURL=DataLayerBuilder.js.map